import { useMutation, useQueryClient } from '@tanstack/react-query'
import { apiClient } from '~/shared/api/data-ingestion-api'

export function useUpdateDocumentPageRanges() {
  const queryClient = useQueryClient()

  return useMutation({
    ...apiClient.updateClusterDocumentPageRangesConsignmentsKeyDocumentPageRangesPutMutation(),
    onSuccess: (_, options) => {
      queryClient.invalidateQueries(
        apiClient.getConsignmentConsignmentsKeyGetOptions({ path: { key: options.path.key } }),
      )
      queryClient.invalidateQueries(apiClient.listConsignmentsConsignmentsGetOptions())
      queryClient.invalidateQueries(apiClient.listDocumentsDocumentsGetOptions())
    },
  })
}
